import { useCallback } from 'react';

import type { UseInputIntentResult } from '@atlassian/search-intent-detection/use-input-intent';

import {
	type CounterfactualIntentDecisionAttributes,
	onCounterfactualIntentDecision,
} from '../../common/utils/quick-find/events/counterfactual-intent-decision';
import {
	getCommonQueryAttributes,
	useQuickFindAnalytics,
	useQuickFindAttributes,
} from './analytics';

export const useCounterfactualIntentDecision = (
	intentDetection?: UseInputIntentResult,
): (({ query }: { query: string }) => void) => {
	const { fireAnalyticsEvent } = useQuickFindAnalytics();
	const { commonAttributes } = useQuickFindAttributes();

	return useCallback(
		({ query }) => {
			if (!intentDetection) {
				return;
			}
			const { intent, source } = intentDetection;
			const scorecardAttributes: CounterfactualIntentDecisionAttributes = {
				detectorSource: source,
				enginePrediction: intent?.type,
				modelId: intent?.modelVersion,
				patternType: intent?.pattern,
			};

			fireAnalyticsEvent(
				onCounterfactualIntentDecision({
					attributes: {
						...commonAttributes,
						...getCommonQueryAttributes(query),
						...scorecardAttributes,
					},
				}),
			);
		},
		[commonAttributes, fireAnalyticsEvent, intentDetection],
	);
};
